module.exports = __webpack_public_path__ + "img/train-11.c6ab7020.jpg";